module.exports = __webpack_public_path__ + "img/1539361796.3b5bb2cc.jpg";